var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('van-empty',{attrs:{"description":"抱歉, 您要看的页面找不到了"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }